
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2024/01/using-streamlit-to-build-web-applications",
      function () {
        return require("private-next-pages/blog-post/2024/01/using-streamlit-to-build-web-applications.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2024/01/using-streamlit-to-build-web-applications"])
      });
    }
  